// Mirrors seeds-react/seeds-react-menu/src/v3/storyData.tsx so the Menu v3 docs
// examples use the same data as the v3 Storybook stories.
import React from "react";

export const books = [
  { id: "book-1", title: "To Kill a Mockingbird", author: "Harper Lee" },
  { id: "book-2", title: "War and Peace", author: "Lev Tolstoy" },
  { id: "book-3", title: "The Idiot", author: "Fyodor Dostoevsky" },
  { id: "book-4", title: "A Picture of Dorian Gray", author: "Oscar Wilde" },
  { id: "book-5", title: "1984", author: "George Orwell" },
  { id: "book-6", title: "Pride and Prejudice", author: "Jane Austen" },
  { id: "book-7", title: "Meditations", author: "Marcus Aurelius" },
  {
    id: "book-8",
    title: "The Brothers Karamazov",
    author: "Fyodor Dostoevsky",
  },
  { id: "book-9", title: "Anna Karenina", author: "Lev Tolstoy" },
  { id: "book-10", title: "Crime and Punishment", author: "Fyodor Dostoevsky" },
];

// Generate 1000 books for virtualization testing
const generateBooks = (count) => {
  const authors = [
    "Harper Lee",
    "Lev Tolstoy",
    "Fyodor Dostoevsky",
    "Oscar Wilde",
    "George Orwell",
    "Jane Austen",
    "Marcus Aurelius",
    "Ernest Hemingway",
    "Virginia Woolf",
    "James Joyce",
    "Charles Dickens",
    "Mark Twain",
    "J.R.R. Tolkien",
    "C.S. Lewis",
    "Agatha Christie",
    "Arthur Conan Doyle",
    "J.K. Rowling",
    "Stephen King",
    "Isaac Asimov",
    "Ray Bradbury",
    "Aldous Huxley",
    "Kurt Vonnegut",
    "J.D. Salinger",
    "Maya Angelou",
    "Toni Morrison",
    "Gabriel García Márquez",
    "Milan Kundera",
    "Umberto Eco",
    "Haruki Murakami",
    "Chimamanda Ngozi Adichie",
  ];

  const titleWords = [
    "Adventures",
    "Chronicles",
    "Memories",
    "Journey",
    "Quest",
    "Tales",
    "Stories",
    "Legends",
    "Myths",
    "Dreams",
    "Visions",
    "Revelations",
    "Secrets",
    "Mysteries",
    "Shadows",
    "Light",
    "Darkness",
    "Echoes",
    "Whispers",
    "Voices",
    "Songs",
    "Poems",
  ];

  const books = [];
  for (let i = 0; i < count; i++) {
    const author = authors[i % authors.length];
    const titleWord1 =
      titleWords[Math.floor(Math.random() * titleWords.length)];
    const titleWord2 =
      titleWords[Math.floor(Math.random() * titleWords.length)];
    const number = Math.floor(i / authors.length) + 1;
    const title = `${titleWord1} of ${titleWord2} ${number}`;

    books.push({
      id: `book-${i + 1}`,
      author,
      title,
    });
  }

  return books;
};

export const largeBookSet = generateBooks(1000);

export const booksWithDisabled = books.map((book) => ({
  ...book,
  disabled: book.id === "book-3" || book.id === "book-7",
}));

export const itemToString = (item) => item?.title ?? "";

export const renderItem = (item) => (
  <>
    <span style={{ fontWeight: "bold" }}>{item.title}</span>
    <span style={{ fontSize: "12px", color: "#666", marginLeft: "8px" }}>
      by {item.author}
    </span>
  </>
);
